<template lang="pug">
#laudos
    .vazio
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'LaudoGeralModal',
    computed: {
        ...mapGetters(['usuarioLogado']),
        ...mapState(['usuarioIsLaudo'])
    }
};
</script>
<style scoped lang="scss">
#laudos .vazio {
    height: 560px;
    overflow-y: auto;
}
</style>
